import * as types from '../actions/constants'

const INITIAL_STATE = {
    list: [],
    current_professional:{}

};
export default (state = INITIAL_STATE, action) => {
    switch(action.type){
        case types.FETCH_PROFESSIONALS:
            return {...state, list: action.payload}
        case types.SET_PROFESSIONAL:
            return {...state, current_professional: action.payload}
        default:
            return state;


    }
}